<template>
  <div class="change-content-card">
    <p class="change-content-card_title">
      {{ title }}
    </p>
    <div
      v-if="_descriptionShow"
      class="change-content-card_content"
    >
      <p
        v-if="description"
        class="change-content-card_content-text"
      >
        {{ description }}
      </p>
      <LlFileList
        v-if="attaches.length > 0"
        two-item
        narrow
        :attaches="attaches"
        :margin-top="20"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "ChangeContentCard",
  props: {
    attaches: {
      type: Array,
      default() {
        return [];
      },
    },
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
  },
  computed: {
    _descriptionShow() {
      return this.description || this.attaches.length > 0;
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/change-content-card";
</style>